import * as React from "react";
import { isEqual } from 'lodash'
import GoogleMapReact from "google-map-react";
import { meters2ScreenPixels } from "google-map-react/utils";
import { Radius } from "../common/Radius";
import { Marker } from "./components/Marker";
import { IMapCenter } from "src/share/types/common";
import { mapStyle } from "src/share/utils/mapStyle";
import "../Map.css";

interface IMapProps {
  center?: IMapCenter;
  zoom?: number;
  isGrid?: boolean;
  radius: number;
  marker?: boolean;
  draggable?: boolean;
  zoomControl?: boolean;
  initialZoom?: number;
  noLocationData?: boolean;
  onMapChange?: (evt) => void;
  useMarker?: boolean;
  isMapDisabled?: boolean;
  isLocationSelected?: boolean
}
interface IMapState {
  currentCenter: IMapCenter;
  currentZoom: number;
  circleSize: { w: number; h: number };
}

const MILESTOMETERS = 1609.34;

class Map extends React.PureComponent<IMapProps, IMapState> {
  protected static defaultProps = {
    radius: 1,
    center: {
      lat: 9.928069,
      lng: -84.090729
    },
    zoom: 13,
    isLocationSelected: true
  };
  private map: any;
  public constructor(props) {
    super(props);
    this.state = {
      currentCenter: { lat: 0, lng: 0 },
      currentZoom: 1,
      circleSize: meters2ScreenPixels(props.radius * MILESTOMETERS * 2, props.center, props.zoom)
    };
  }
  public componentDidUpdate(prevProps) {
    const differentRadius = prevProps.radius !== this.props.radius
    if (differentRadius && this.map) {
      this.setState({
        circleSize: this.getRadiusSize(this.state.currentCenter, this.state.currentZoom)
      });
    }
    const differentCenter = prevProps.center && this.props.center && isEqual(prevProps, this.props.center)
    if (this.props.isLocationSelected && differentRadius || differentCenter) {
      this.fitToRadius()
    }
  }
  public onInit = mapAPI => {
    this.map = mapAPI.map;
  };
  public fitToRadius() {
    if (this.props.center && this.props.radius) {
      const circle = new google.maps.Circle({
        center: this.props.center,
        radius: this.props.radius * 1500
      });
      if (this.map && this.map.fitBounds) {
        this.map.fitBounds(circle.getBounds());
      }
    }
  }
  private handleChange = ({ center, zoom }) => {
    this.setState({ circleSize: this.getRadiusSize(center, zoom), currentCenter: center, currentZoom: zoom });
    if (this.props.onMapChange) {
      this.props.onMapChange(center);
    }
  };
  private getRadiusSize(center, zoom) {
    if (center && this.props.radius) {
      const { lat, lng } = center;
      return meters2ScreenPixels(this.props.radius * MILESTOMETERS * 2, { lat, lng }, zoom);
    }
    return { w: 0, h: 0 };
  }
  private shouldShowRadius() {
    return !this.props.useMarker && this.props.isLocationSelected && this.props.radius > 0
  }
  public render() {
    return (
      <div className="map">
        {this.shouldShowRadius() && <Radius width={this.state.circleSize.w} height={this.state.circleSize.h} />}
        <GoogleMapReact
          options={{
            zoomControl: false,
            fullscreenControl: false,
            styles: mapStyle
          }}
          onGoogleApiLoaded={this.onInit}
          draggable={!this.props.isMapDisabled}
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY || "" }}
          center={this.props.center}
          zoom={this.props.isLocationSelected ? 13 : 1}
          onChange={this.handleChange}
        >
          {this.props.useMarker && <Marker {...this.props.center} />}
        </GoogleMapReact>
      </div>
    );
  }
}

export default Map;
